import React from "react";
import { Route, Switch } from "react-router-dom";
import { resourcesRoutes } from "./routes";

const ResourcesRouter = () => {
  return (
    <Switch>
      {resourcesRoutes.map((route, index) => (
        <Route key={index} exact={route.exact} path={route.path}>
          <route.main />
        </Route>
      ))}
    </Switch>
  );
};

export default ResourcesRouter;
